import "./markup/scss/app.scss";
import "lodash";

import Vue from "vue";
import Fragment from "vue-fragment";

import $axios from "./prototypes/axios";
import $EventBus from "./prototypes/eventBus";
import $utils from "./prototypes/utils";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import $config from "./config";

import "./layouts";
import "./components";

Vue.config.productionTip = false;

Vue.use(Fragment.Plugin);

Object.assign(Vue.prototype, {
  _,
  $config,
  $axios,
  $EventBus,
  $utils,
});

Vue.mixin({
  data() {
    return {
      uuid: _.uniqueId('c')
    }
  },
  methods: {
    openPopup() {
      this.$EventBus.$emit("openPopup", ...arguments);
    },
    async openHelp(contentId) {
      const module = await import("./components/help/HelpPopup");
      this.openPopup(module.default, { contentId });
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
